$ = jQuery;

var  event = $('.jc-saiba-mais a').data('track');

/*
* Evento de clique no Saiba mais
*/
$('.jc-saiba-mais').on('click', "a", function() {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Saiba Mais',
    'eventAction': 'Clique - Saiba Mais - ' + event,
    'eventLabel': $(this).find('a').data('track')
  });

  gtag('event', 'Saiba Mais', {
    'eventAction': 'Clique - Saiba Mais - ' + event,
    'eventLabel': $(this).find('a').data('track')
  });
});

/*
* Evento de impressão no Saiba mais
*/

dataLayer.push({
  'event': 'ga_event',
  'eventCategory': 'Saiba Mais',
  'eventAction': 'Impressão - Saiba Mais - ' + event,
  'eventLabel': 'Impressão Saiba Mais'
});

gtag('event', 'Saiba Mais', {
  'eventAction': 'Impressão - Saiba Mais - ' + event,
  'eventLabel': 'Impressão Saiba Mais'
});

